import { render } from "./add-subject.vue?vue&type=template&id=420460a8"
import script from "./add-subject.vue?vue&type=script&lang=js"
export * from "./add-subject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__